import {
  createContext,
  useState,
  useCallback,
  useMemo,
  useEffect,
} from 'react';

import { ArchivalUnitReference, NewOrder } from 'types';

// Archival units are stored in the cart, so it is neccessary for them to be stored also in localstorage
export const CART_ARCHIVAL_UNITS = 'cart-archival-units-v2';

type ArchivalUnitRefWithPath = {
  archivalUnitReference: ArchivalUnitReference;
  path: string;
};

interface OrderCtxType {
  aisOrder?: NewOrder;
  archivalUnits?: ArchivalUnitRefWithPath[];
  handleAisOrder?: (aisOrder?: NewOrder) => void;
  //handleUnits?: (units: ArchivalUnitReference[]) => void;
  handleAddUnit?: (unit: ArchivalUnitReference, path: string) => void;
  handleRemoveUnit?: (unit: ArchivalUnitReference) => void;
  clearContext?: () => void;
  isArchivalUnitInOrder?: (archivalAidNumericId?: number) => boolean;
}

export const OrderCtx = createContext<OrderCtxType>({});

export function useOrderCtx() {
  const [aisOrder, setAisOrder] = useState<NewOrder | undefined>();
  const [archivalUnits, setArchivalUnits] = useState<ArchivalUnitRefWithPath[]>(
    JSON.parse(localStorage.getItem(CART_ARCHIVAL_UNITS) || '[]')
  );

  const handleAisOrder = useCallback((aisOrder?: NewOrder) => {
    setAisOrder(aisOrder);
    setArchivalUnits([]);
  }, []);

  // const handleUnits = useCallback((newUnits: ArchivalUnitReference[]) => {
  //   setArchivalUnits(newUnits);
  //   setAisOrder(undefined);
  // }, []);

  const handleAddUnit = useCallback(
    (unit: ArchivalUnitReference, path: string) => {
      setArchivalUnits((units) =>
        units.some(
          ({ archivalUnitReference }) => archivalUnitReference.id === unit?.id
        )
          ? units
          : [...units, { archivalUnitReference: unit, path }]
      );
      setAisOrder(undefined);
    },
    []
  );

  const handleRemoveUnit = useCallback((unit: ArchivalUnitReference) => {
    setArchivalUnits((units) =>
      units.filter(
        ({ archivalUnitReference }) => archivalUnitReference.id !== unit?.id
      )
    );
    setAisOrder(undefined);
  }, []);

  const clearContext = useCallback(() => {
    setAisOrder(undefined);
    setArchivalUnits([]);
  }, []);

  const isArchivalUnitInOrder = useCallback(
    (archivalNumericId?: number) =>
      archivalUnits?.some(
        ({ archivalUnitReference }) =>
          archivalUnitReference.numericId === archivalNumericId
      ),
    [archivalUnits]
  );

  useEffect(() => {
    localStorage.setItem(CART_ARCHIVAL_UNITS, JSON.stringify(archivalUnits));
  }, [archivalUnits]);

  const orderCtx: OrderCtxType = useMemo(
    () => ({
      aisOrder,
      archivalUnits,
      handleAisOrder,
      //handleUnits,
      handleAddUnit,
      handleRemoveUnit,
      clearContext,
      isArchivalUnitInOrder,
    }),
    [
      aisOrder,
      archivalUnits,
      handleAisOrder,
      //handleUnits,
      handleAddUnit,
      handleRemoveUnit,
      clearContext,
      isArchivalUnitInOrder,
    ]
  );
  return orderCtx;
}
